import { BreakpointsOptions } from '@mui/system/createTheme/createBreakpoints';

export const breakpoints: BreakpointsOptions = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: { xs: 0, sm: 568, md: 768, lg: 1200, xl: 1441 },
};
